import type { ReactNode } from "react";
import { Link } from "react-router";
import { Lock } from "lucide-react";
import { Card, CardTitle, Subtitle, VButton } from "@/components/ui";
import { useCurrentRole } from "@/domains/auth/hooks/useCurrentUser";
import type { Role } from "@/domains/auth/api/types";
import { ROLE_LABELS } from "@/domains/auth/components/roleLabels";

type RequireRoleProps = {
  roles: ReadonlyArray<Role>;
  children: ReactNode;
};

export function RequireRole({ roles, children }: RequireRoleProps): React.JSX.Element {
  const role = useCurrentRole();
  if (roles.includes(role)) {
    return <>{children}</>;
  }
  return (
    <Card padding="lg" className="mx-auto max-w-xl text-center">
      <div className="flex flex-col items-center gap-3">
        <Lock className="size-10 text-muted-foreground" aria-hidden />
        <CardTitle>Geen toegang</CardTitle>
        <Subtitle>
          Deze pagina is enkel toegankelijk voor: {roles.map((r) => ROLE_LABELS[r]).join(", ")}.
          Wissel rol via de gebruikersknop rechts bovenaan.
        </Subtitle>
        <VButton asChild variant="outline" size="sm">
          <Link to="/">Terug naar dashboard</Link>
        </VButton>
      </div>
    </Card>
  );
}
